export default Object.freeze({

});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/cms/actions.js